import { render, staticRenderFns } from "./machine-details.vue?vue&type=template&id=e8fc10c8&"
import script from "./machine-details.vue?vue&type=script&lang=js&"
export * from "./machine-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports